<div class="feedback-wrapper container"
     [className]="feedbackStype">
  <ng-container *ngIf="currentFeedbackFormType===FEEDBACK_FORM_TYPE.COLLAPSED">
    <div class="collapsed-feedback">
      <h2 class="feedback-label">Feedback?</h2>
      <button adapt-button
              id="feedback-positive"
              class="feedback-button"
              btn-type="primary"
              type="button"
              size="default"
              (click)="onFeedbackStart(FEEDBACK_FORM_TYPE.POSITIVE)">
        <span class="d-icon-thumb_up_adapt"></span>
      </button>
      <button adapt-button
              id="feedback-negative"
              class="feedback-button"
              btn-type="primary"
              type="button"
              size="default"
              (click)="onFeedbackStart(FEEDBACK_FORM_TYPE.NEGATIVE)">
        <span class="d-icon-thumb_down_adapt"></span>
      </button>
    </div>
  </ng-container>

  <div #negativeTarget>
    <ng-container *ngIf="currentFeedbackFormType===FEEDBACK_FORM_TYPE.NEGATIVE">
      <form class="negative-feedback"
            [formGroup]="feedbackForm"
            (ngSubmit)="submitFeedbackForm()">
        <h2>What is not right?</h2>
        <div class="row">

          <div class="col-sm-6">
            <div class="tcp-checkbox-wrapper">
              <adapt-rx-checkbox id="feedback-negative_difficultToUse" formControlName="difficultToUse"
                                 label="Difficult to use"></adapt-rx-checkbox>
              <adapt-rx-checkbox id="feedback-negative_featureRequest" formControlName="featureRequest"
                                 label="Feature request"></adapt-rx-checkbox>
              <adapt-rx-checkbox id="feedback-negative_missingInfo" formControlName="missingInfo"
                                 label="Missing information"></adapt-rx-checkbox>
              <adapt-rx-checkbox id="feedback-negative_appNotWorkingAsExpected"
                                 formControlName="appNotWorkingAsExpected"
                                 label="Application not working as expected"></adapt-rx-checkbox>
            </div>
          </div>
          <div class="col-sm-6 massage-feedback">
            <adapt-rx-textarea id="feedback-negative_message"
                               formControlName="message"
                               [label]="'Your feedback:'"
                               [placeholder]="'Start typing...'"
                               [rows]="5">
            </adapt-rx-textarea>
          </div>

          <div class="col-sm-12 buttons-wrapper">
            <button adapt-button
                    id="feedback-negative_cancel"
                    btn-type="secondary"
                    (click)="cancelFeedbackForm()">
              <span>Cancel</span>
            </button>
            <button adapt-button
                    id="feedback-negative_submit"
                    btn-type="primary"
                    type="submit">
              <span>Send</span>
            </button>
          </div>
        </div>
      </form>

    </ng-container>
  </div>

  <div #positiveTarget>
    <ng-container *ngIf="currentFeedbackFormType===FEEDBACK_FORM_TYPE.POSITIVE">
      <form class="positive-feedback"
            [formGroup]="feedbackForm"
            (ngSubmit)="submitFeedbackForm()">
        <div class="massage-feedback">
          <adapt-rx-textarea id="feedback-positive_message"
                             formControlName="message"
                             [label]="'Your feedback:'"
                             [placeholder]="'Start typing...'"
                             [rows]="4">
          </adapt-rx-textarea>
        </div>

        <div class="col-sm-12 buttons-wrapper">
          <button id="feedback-positive_cancel"
                  adapt-button
                  btn-type="secondary"
                  (click)="cancelFeedbackForm()">
            <span>Cancel</span>
          </button>
          <button id="eedback-positive_send"
                  adapt-button
                  btn-type="primary"
                  type="submit">
            <span>Send</span>
          </button>
        </div>
      </form>
    </ng-container>
  </div>

